import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const rows = [{
    sit: 'Cada noche sin saber qué cocinar',
    bad: 'Delivery o fideos otra vez',
    good: 'Receta en 15 min ya decidida'
  }, {
    sit: 'Presupuesto en comida',
    bad: 'Gastás de más, tirás comida',
    good: 'Lista inteligente, sin desperdiciar'
  }, {
    sit: 'Cuando viene la suegra',
    bad: 'Vergüenza o pedido al restaurante',
    good: 'Menú completo listo para ejecutar'
  }, {
    sit: 'Aprender a cocinar',
    bad: 'Horas de YouTube sin resultado',
    good: 'Sistema en un fin de semana'
  }, {
    sit: 'Tiempo en la cocina',
    bad: 'Improvisando cada vez',
    good: 'Planificación semanal de 10 min'
  }, {
    sit: 'Confianza cocinando',
    bad: 'Cero · dependés de otros',
    good: 'Independencia total desde el día 3'
  }];
  return <section className="py-10 md:py-20 bg-brand-panel/85 backdrop-blur-sm border-y border-brand-border" data-id="element-34">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-36">
          <span className="text-brand-red font-bold tracking-widest uppercase text-xs md:text-sm mb-3 md:mb-4 block" data-id="element-37">
            La Realidad
          </span>
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-white" data-id="element-38">
            ¿Cuánto te cuesta no tenerlo?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full" data-id="element-39">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-40">
            <thead data-id="element-41">
              <tr data-id="element-42">
                <th className="p-1.5 md:p-4 border-b border-brand-border text-gray-400 font-normal w-1/3 text-[10px] md:text-base align-bottom" data-id="element-43">
                  Situación
                </th>
                <th className="p-1.5 md:p-4 border-b border-brand-border text-brand-red font-bold w-1/3 text-center bg-brand-red/5 rounded-tl-xl text-[10px] md:text-base align-bottom" data-id="element-44">
                  Sin el sistema
                </th>
                <th className="p-1.5 md:p-4 border-b border-brand-border text-brand-gold font-bold w-1/3 text-center bg-brand-gold/5 rounded-tr-xl text-[10px] md:text-base align-bottom" data-id="element-45">
                  Con el sistema
                </th>
              </tr>
            </thead>
            <tbody data-id="element-46">
              {rows.map((r, i) => <motion.tr initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} key={i} className="border-b border-brand-border/50 hover:bg-brand-dark/50 transition-colors" data-id="element-47">
                  <td className="p-1.5 md:p-4 text-white font-medium text-[10px] leading-tight md:text-base align-top" data-id="element-48">
                    {r.sit}
                  </td>
                  <td className="p-1.5 md:p-4 text-gray-400 text-center bg-brand-red/5 align-top" data-id="element-49">
                    <div className="flex flex-col md:flex-row items-center justify-center gap-0.5 md:gap-2" data-id="element-50">
                      <X className="w-3 h-3 md:w-4 md:h-4 text-brand-red flex-shrink-0" data-id="element-51" />
                      <span className="text-[10px] leading-tight md:text-base" data-id="element-52">
                        {r.bad}
                      </span>
                    </div>
                  </td>
                  <td className="p-1.5 md:p-4 text-white text-center bg-brand-gold/5 align-top" data-id="element-53">
                    <div className="flex flex-col md:flex-row items-center justify-center gap-0.5 md:gap-2" data-id="element-54">
                      <Check className="w-3 h-3 md:w-4 md:h-4 text-brand-gold flex-shrink-0" data-id="element-55" />
                      <span className="font-semibold text-[10px] leading-tight md:text-base" data-id="element-56">
                        {r.good}
                      </span>
                    </div>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}